<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12l5 5L20 7" />
  </svg>
</template>

<script>
export default {
  name: 'IconCheck',
  props: {
    size: { type: [String, Number], default: 12 },
    strokeWidth: { type: [String, Number], default: 3.5 },
  },
};
</script>
